import { put, call, select, takeEvery, delay } from 'redux-saga/effects'
import * as PIXI from 'pixi.js'
import { LOAD_ASSETS, UPDATE_PROGRESS, SET_GAMESPEED, assetTypes } from 'macguffin/redux/constants'
import { setSpineHash } from '../utils'

const assetType = 'assets'
let assetLoadProgress = 0

export default function* watchLoadData() {
  yield takeEvery(LOAD_ASSETS, loadAssets)
  yield takeEvery(SET_GAMESPEED, onSetGamespeed)
}

function onSetGamespeed(action) {
  PIXI.Ticker.shared.speed = action.gamespeed
}

function updateProgress(value) {
  assetLoadProgress = value
}

function* progressLoop() {
  let progress = 0
  while (progress < 100) {
    yield delay(50)

    const { assetProgress } = yield select(state => state.base)

    progress = (assetProgress[assetType]) || 0

    if (progress < assetLoadProgress) {
      yield put({
        type: UPDATE_PROGRESS,
        asset: assetType,
        progress: assetLoadProgress,
      })
      progress = assetLoadProgress
    }
  }
}

function* loadAssets(action) {
  const { Assets } = action

  const assets = Assets.filter(asset => asset.type === assetTypes.asset)

  assets.forEach(asset => PIXI.Loader.shared.add(asset.id, asset.src))

  PIXI.Loader.shared.onProgress.add(() => updateProgress(PIXI.Loader.shared.progress))
  PIXI.Loader.shared.onLoad.add((l, file) => {
    if (file.data && file.data.skeleton) {
      setSpineHash(file.name, file.data.skeleton.hash)
    }
  })

  if (assets.length > 0) {
    PIXI.Loader.shared.onComplete.add(() => {
      updateProgress(100)
    })
    PIXI.Loader.shared.load()
  } else {
    updateProgress(100)
  }

  yield call(progressLoop)
}
